module.exports = __webpack_public_path__ + "static/img/fox.3848d55.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mex/report-assets/fox.png
// module id = 1309
// module chunks = 8